const LeaderboardType = {
  GLOBAL: 'GLOBAL',
  FRIENDS: 'FRIENDS',
  GROUP: 'GROUP',
};

export default LeaderboardType;
